
























import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import i18n from "../i18n";
import Component from "vue-class-component";
import { HomeActionTypes, HomeState, namespaceHome } from "../store/home";
import AppHeading from "@/components/AppHeading.vue";
import AppSportEventList from "@/components/AppSportEventList.vue";
import AppTimeline from "@/components/Timeline/AppTimeline.vue";
import { SportEvent } from "../models/sport-events.model";
import HomeEventsSwiper from "./Home/HomeEventsSwiper.vue";
import HomeStatistics from "./Home/HomeStatistics.vue";
import { namespaceAuth } from "../store/auth";
import { namespaceTimeline, TimelineState, TimelineActionTypes } from "../store/timeline";
import { PAGINATION_FIRST_PAGE } from "../constants";

const SPORT_EVENT_LIST_COUNT_WITH_TIMELINE = 4;

@Component({
  name: "home",
  computed: {
    ...mapState<HomeState>(namespaceHome, {
      statistics: (state: HomeState) => state.statistics,
      sportEventsList: (state: HomeState) => state.sportEventsList
    }),
    ...mapGetters(namespaceAuth, {
      isLoggedIn: "isLoggedIn"
    }),
    ...mapState<TimelineState>(namespaceTimeline, {
      timeline: (state: TimelineState) => state.timeline,
      timelinePerPage: (state: TimelineState) => state.paginationMeta.per_page,
      timelineTotal: (state: TimelineState) => state.paginationMeta.total
    })
  },
  components: {
    HomeEventsSwiper,
    HomeStatistics,
    AppHeading,
    AppSportEventList,
    AppTimeline
  }
})
export default class HomePage extends Vue {
  isLoggedIn!: boolean;
  sportEventsList!: SportEvent[];

  mounted() {
    this.$store.dispatch(`${namespaceHome}/${HomeActionTypes.FetchStatistics}`);
    this.$store.dispatch(`${namespaceHome}/${HomeActionTypes.FetchSportEventsList}`);

    if (this.isLoggedIn) {
      this.getTimeline(PAGINATION_FIRST_PAGE);
    }
  }

  get showTimeline() {
    return this.isLoggedIn;
  }

  get sportEvents() {
    return this.showTimeline ? this.sportEventsList.slice(0, SPORT_EVENT_LIST_COUNT_WITH_TIMELINE) : this.sportEventsList;
  }

  getTimeline(page: number) {
    this.$store.dispatch(`${namespaceTimeline}/${TimelineActionTypes.FetchTimeline}`, { page });
  }
}
